import Page from './components/Page'
import { KB_PAGE } from './pages'

export default {
  [KB_PAGE]: {
    path: '/reports/kb/articles',
    component: Page,
  },
}
